import { render, staticRenderFns } from "./steppers.vue?vue&type=template&id=81a37f2e&scoped=true&"
import script from "./steppers.vue?vue&type=script&lang=js&"
export * from "./steppers.vue?vue&type=script&lang=js&"
import style0 from "./steppers.vue?vue&type=style&index=0&id=81a37f2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a37f2e",
  null
  
)

export default component.exports